module.exports = __webpack_public_path__ + "img/medi-mass-footer.6f9b16a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medi-mass/medi-mass-footer.jpg
// module id = 613
// module chunks = 5